import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../app/core/services/authentication.serivce';
import { RouterExtensionsService } from '../app/core/services/router-extensions.service';
import { Router, Event, NavigationEnd, NavigationStart } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { fadeAnimation } from '../app/shared/utilities/animations';
import { DrawerSelectEvent } from "@progress/kendo-angular-layout";
import { AuthGuard } from './core/utilities/auth.guard';
import { Permission } from './core/literals/permission.literal';
import { SecurityRole } from './shared/literals/shared.literal';
import { GetOrganizationServicesService } from '../app/core/services/get-services.service';
import { Services } from './shared/literals/shared.literal';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs';

interface NavBarButtons {
  text: string;
  icon: string;
  path: string;
  cssClass?: string;
  selected?: boolean;
  adminPage?: boolean;
  canView: boolean;
  viewPermission?: number;
  viewPermissionByOrganization?: number;
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    animations: [fadeAnimation],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'Epc.Iinvision.Redeployment';

  username: string = "";
  password: string = "";
  isVisible: boolean = false;
  needsToChangePassword: boolean = false;
  userName: string;
  organizationName: string;
  organizationId: number;

  protected subscription: Subject<boolean>;

  public expanded = true;
  public items: Array<NavBarButtons> = [];
/*  public menuSvg: SVGIcon = menuIcon;*/

  ngOnInit(): void {
    if (!this.isVisible) {
      var bar = document.getElementById("app-bar") as HTMLDivElement;
      bar.style.height = "45px";
    }

    if (!this.isVisible) {
      var drawer = document.getElementById("drawer") as HTMLDivElement;
      drawer.style.display = "none"; //this probably needs to change
    }

    this.items = this.items.filter(
      item => item.text != undefined && item.canView === true)
  }

  constructor(private translate: TranslateService,
              private auth: AuthenticationService,
              private router: Router,
              private titleService: Title,
              private res: RouterExtensionsService,
              private getServices: GetOrganizationServicesService) {

    var browserLanguage = translate.getBrowserCultureLang(); // this gets "en-US", "es-MX", etc
    if (!browserLanguage) {
      browserLanguage = "en";
    }

    this.titleService.setTitle('Redeployment');

    //translate.setDefaultLang(browserLanguage);
    //translate.use(browserLanguage);

    if (auth.isLoggedIn()) {
      this.isVisible = true;
    }

    var session = auth.getSession();
    if (session) {
      //if this is a general user, they should only have ONE organization
      if (session.securityRoleId != Number(SecurityRole.Administrator) && session.permissions.length == 1) {
        this.organizationName = session.permissions[0].name;
        this.organizationId = session.permissions[0].id;
      } else {
        this.organizationName = session.organizationName;
        this.organizationId = session.organizationId;
      }
    }

    if (auth.isLoggedIn() && session?.needsToChangePassword.toLowerCase() == "true") {
      this.needsToChangePassword = true;
    }

    this.items = this.mapItems(router.config as NavBarButtons[]);
    this.items[0].selected = true;

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.res.setCurrentUrl(this.router.url);
      }

      if (event instanceof NavigationEnd) {
        if (auth.isLoggedIn()) {
          this.isVisible = true;

          if (this.isVisible) {
            var bar = document.getElementById("app-bar") as HTMLDivElement;
            bar.style.height = "40px";

            var drawer = document.getElementById("drawer") as HTMLDivElement;
            drawer.style.display = "";
          }
          var session = auth.getSession();
          if (session) {
            var name = session.name;
            var parts = name.split(' ');
            var username = parts[0] + " " + parts[1].substring(0, 1) + ".";

            this.userName = username;
            

            //if this is a general user, they should only have ONE organization
            if (session.securityRoleId != Number(SecurityRole.Administrator) && session.permissions.length == 1) {
              this.organizationName = session.permissions[0].name;
              this.organizationId = session.permissions[0].id;
            } else {
              this.organizationName = session.organizationName;
              this.organizationId = session.organizationId;
            }
          }
        } else {
          var drawer = document.getElementById("btnOrganization") as HTMLDivElement;
          if (drawer != undefined && drawer != null) {
            drawer.style.display = "none";
          }

          var drawer = document.getElementById("btnUser") as HTMLDivElement;
          if (drawer != undefined && drawer != null) {
            drawer.style.display = "none";
          }
        }
      }
    });
  }

  public onSelect(ev: DrawerSelectEvent): void {
    this.router.navigate([ev.item.path]);
  }

  public mapItems(routes: NavBarButtons[]): NavBarButtons[] {
    return routes.map((item) => {
      return {
        text: item.text,
        icon: item.icon,
        path: item.path ? item.path : "",
        canView: this.canview(item.viewPermission) && this.canViewByOrganization(item.viewPermissionByOrganization)
      };
    });
  }

  public canview(permission: number | undefined): boolean {
    var auth = this.auth;

    if (auth && auth.canPerformAction(Number(permission))) {
      return true;
    } else {
      return false;
    }
  }

  public canViewByOrganization(service: Services | undefined): boolean {
    var auth = this.auth;

    if (auth && auth.canPerformActionByService(service)) {
      return true;
    } else {
      return false;
    }
  }
}
